// extracted by mini-css-extract-plugin
export default {"container":"styles__container--o7A4k"};